export const DataServiceManagementPage = () => {
  return (
    <>
      <h1>data service management page</h1>
    </>
  );
};
